import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useFormContext } from 'react-hook-form';
import { AddCharge } from '~/components/BillModal/components/AddCharge/AddCharge';
import { BillItemsTable } from '~/components/BillModal/components/BillItemsTable/BillItemsTable';
import { useBillItems } from '~/components/BillModal/hooks/useBillItems';
import { useCreateServiceTemplateForBill } from '~/components/BillModal/hooks/useCreateServiceTemplateForBill';
import { createEmptyChargeItem, seedChargeItemFromTemplate } from '~/components/BillModal/utils/lineItem.utils';
import { useStore } from '~/contexts';
import { selectors } from '~/store/state-selectors';
import { formatTemplateCost } from '../AdHocBillModal.utils';
const EMPTY_AGREEMENT_OPTIONS = [];
export function AdHocBillItemsSection(param) {
    let { relationship, outOfScopeTemplates, addChargeLabel, disabledItems, disabledRowTooltip, testIds } = param;
    const { appendItem, replaceItem } = useBillItems();
    const { getValues } = useFormContext();
    const descriptionEnabled = useStore(selectors.user.invoiceLineItemDescriptionEnabled);
    const { openCreateServiceTemplate } = useCreateServiceTemplateForBill({
        relationship
    });
    const onSelectItem = (rowIndex, selection)=>{
        if (selection.kind !== 'outOfScopeTemplate') return;
        const { itemId } = getValues("items.".concat(rowIndex));
        replaceItem(rowIndex, _object_spread_props(_object_spread({}, seedChargeItemFromTemplate(selection.template, {
            descriptionEnabled
        })), {
            itemId
        }));
    };
    const onClearItem = (rowIndex)=>replaceItem(rowIndex, createEmptyChargeItem());
    const onCreateNewItem = async (rowIndex)=>{
        const { itemId } = getValues("items.".concat(rowIndex));
        const template = await openCreateServiceTemplate();
        if (template == null) return;
        replaceItem(rowIndex, _object_spread_props(_object_spread({}, seedChargeItemFromTemplate(template, {
            descriptionEnabled
        })), {
            itemId
        }));
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(BillItemsTable, {
                includePreapproved: false,
                hideChargeApprovalCallout: true,
                disabledItems: disabledItems,
                disabledRowTooltip: disabledRowTooltip,
                itemSelect: {
                    agreementOptions: EMPTY_AGREEMENT_OPTIONS,
                    outOfScopeTemplates,
                    formatTemplateCost,
                    onSelectItem,
                    onClearItem,
                    onCreateNewItem
                },
                testId: testIds.Lines(),
                bi: {
                    editButton: {
                        name: 'edit_ad_hoc_bill_item'
                    },
                    removeButton: {
                        name: 'delete_ad_hoc_bill_item'
                    }
                }
            }),
            /*#__PURE__*/ _jsx(AddCharge, {
                agreementOptions: EMPTY_AGREEMENT_OPTIONS,
                outOfScopeTemplates: outOfScopeTemplates,
                formatTemplateCost: formatTemplateCost,
                flat: true,
                triggerVariant: "dashedBox",
                triggerLabel: addChargeLabel,
                onSelect: (selection)=>selection.kind === 'outOfScopeTemplate' && appendItem(seedChargeItemFromTemplate(selection.template, {
                        descriptionEnabled
                    })),
                onCreateNew: async ()=>{
                    const template = await openCreateServiceTemplate();
                    if (template != null) appendItem(seedChargeItemFromTemplate(template, {
                        descriptionEnabled
                    }));
                },
                bi: {
                    trigger: {
                        name: 'add_ad_hoc_charge'
                    },
                    search: {
                        name: 'add_ad_hoc_charge_search'
                    },
                    createNew: {
                        name: 'create_new_ad_hoc_charge'
                    }
                },
                testId: testIds.AddCharge()
            })
        ]
    });
}
